export default __webpack_public_path__ + "static/media/smardtv_hover.624c295e.png";